import { FC } from 'react';
import { PageScroll } from '@anton.bobrov/react-components';
import { LayoutContainer } from '@/components/layout/Container';
import { IHome } from './types';
import { registry } from './registry';
import styles from './styles.module.scss';
const Home: FC<IHome> = ({
  components
}) => <PageScroll.SmoothContainer data-sentry-element="unknown" data-sentry-component="Home" data-sentry-source-file="index.tsx">
    <LayoutContainer hasXPadding={false} hasTopPadding={false} hasMainTopPadding={false} data-sentry-element="LayoutContainer" data-sentry-source-file="index.tsx">
      <div className={styles.grid}>
        {registry.render(components, {
        cssModule: styles,
        order: ['HomeIntro']
      })}
      </div>
    </LayoutContainer>
  </PageScroll.SmoothContainer>;
export default Home;